import React, { useState } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';
import { Helmet } from 'react-helmet-async';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage><IonContent>
    <main className="container py-4" style={{ maxWidth: 440, margin: '0 auto' }}>
      <Helmet><title>Reset Password | QA Master</title></Helmet>
      <div>
              <div style={{ textAlign: 'center', marginTop: 60, marginBottom: 40 }}>
                <h1 style={{
                  fontSize: 32, fontWeight: 700, margin: 0,
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
                }}>QA Master</h1>
                <p style={{ color: '#666', marginTop: 8 }}>Reset your password</p>
              </div>

        <div className="bg-white rounded-3 shadow-sm p-4">
          {sent ? (
            <div className="text-center py-3">
              <div
                className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3"
                style={{ width: 64, height: 64, background: 'rgba(102,126,234,0.1)', fontSize: 28 }}
              >
                &#9993;
              </div>
              <h5 className="mb-2">Check your email</h5>
              <p className="text-muted small">
                If an account exists for <strong>{email}</strong>, we've sent a password reset link.
                Check your inbox and spam folder.
              </p>
              <Link to="/login">
                <Button variant="outline-primary" className="mt-2">Back to Sign In</Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}

              <p className="text-muted small mb-3">
                Enter your email address and we'll send you a link to reset your password.
              </p>

              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold small">Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </Form.Group>

              <Button
                type="submit"
                className="w-100 btn-brand-gradient fw-semibold"
                disabled={loading}
              >
                {loading ? <Spinner animation="border" size="sm" /> : 'Send Reset Link'}
              </Button>
            </form>
          )}
        </div>

        <p className="text-center text-muted mt-4 small">
          Remember your password?{' '}
          <Link to="/login" className="fw-semibold text-decoration-none">Sign in</Link>
        </p>
      </div>
    </main>
    </IonContent></IonPage>
  );
};

export default ForgotPassword;
